(() => {
  if (customElements.get('yrp-asics-carousel')) return;
class AsicsBase extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.yrp-necklaces__track');
      this.cards = Array.from(this.track.children);
      if (this.cards.length < 2) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const cloneCards = () => this.cards.map(card => {
        const clone = card.cloneNode(true);
        clone.dataset.carouselClone = '';
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a,button,input,[tabindex]').forEach(el => el.tabIndex = -1);
        return clone;
      });
      this.leadingCards = cloneCards();
      this.track.prepend(...this.leadingCards);
      this.track.append(...cloneCards());
      this.measure = () => {
        const oldCycle = this.cycle || 0;
        const progress = oldCycle ? (this.track.scrollLeft - oldCycle) / oldCycle : 0;
        this.cycle = this.cards[0].offsetLeft - this.leadingCards[0].offsetLeft;
        if (this.cycle) this.track.scrollLeft = this.cycle * (1 + progress);
      };
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this.track);
      this.measure();
      this.track.addEventListener('scroll', () => {
        if (!this.cycle) return;
        let shift = 0;
        if (this.track.scrollLeft < this.cycle * .5) shift = this.cycle;
        else if (this.track.scrollLeft >= this.cycle * 1.5) shift = -this.cycle;
        if (shift) {
          this.track.scrollLeft += shift;
          if (this.drag) this.drag.startScroll += shift;
        }
      }, { passive: true, signal });
      this.querySelectorAll('[data-direction]').forEach(button => {
        button.addEventListener('click', () => this.move(Number(button.dataset.direction)), { signal });
      });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal });
      this.track.addEventListener('dragstart', event => event.preventDefault(), { signal });
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.suppressClick = false;
        this.drag = { startX: event.clientX, startScroll: this.track.scrollLeft, moved: false };
      }, { signal });
      this.track.addEventListener('pointermove', event => {
        if (!this.drag) return;
        const distance = event.clientX - this.drag.startX;
        if (!this.drag.moved && Math.abs(distance) > 5) {
          this.drag.moved = true;
          this.track.setPointerCapture(event.pointerId);
          this.track.dataset.dragging = '';
        }
        if (this.drag.moved) {
          event.preventDefault();
          this.track.scrollLeft = this.drag.startScroll - distance;
        }
      }, { signal });
      const finish = () => {
        this.suppressClick = Boolean(this.drag && this.drag.moved);
        this.drag = null;
        delete this.track.dataset.dragging;
      };
      this.track.addEventListener('pointerup', finish, { signal });
      this.track.addEventListener('pointercancel', finish, { signal });
      this.track.addEventListener('pointerleave', () => {
        if (this.drag && !this.drag.moved) this.drag = null;
      }, { signal });
      this.track.addEventListener('click', event => {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }, { capture: true, signal });
    }
    move(direction) {
      const step = this.cards[1].offsetLeft - this.cards[0].offsetLeft;
      this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.track?.querySelectorAll('[data-carousel-clone]').forEach(card => card.remove());
      this.controller = null;
    }

}

    if (customElements.get('yrp-asics-carousel')) return;
    customElements.define('yrp-asics-carousel', class extends AsicsBase {
      connectedCallback() {
        if (this.autoController) return;
        super.connectedCallback();
        if (!this.controller || this.cards.length < 2) return;
        this.autoController = new AbortController();
        const signal = this.autoController.signal;
        this.pauseButton = this.querySelector('[data-auto-pause]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.speed = Number(this.dataset.speed) || 30;
        this.manualPause = false;
        this.hovered = false;
        this.focused = false;
        this.interacting = false;
        this.onScreen = false;
        this.frame = time => {
          const elapsed = this.lastTime ? Math.min(time - this.lastTime,64) : 0;
          this.lastTime = time;
          if (this.cycle) {
            this.fractionalStep = (this.fractionalStep || 0) + this.speed * elapsed / 1000;
            const pixels = Math.trunc(this.fractionalStep);
            if (pixels) this.track.scrollLeft += pixels;
            this.fractionalStep -= pixels;
          }
          this.animationFrame = requestAnimationFrame(this.frame);
        };
        this.sync = () => {
          const running = this.onScreen && !document.hidden && !this.motion.matches && !this.manualPause && !this.hovered && !this.focused && !this.interacting;
          if (running && !this.animationFrame) {
            this.lastTime = 0;
            this.animationFrame = requestAnimationFrame(this.frame);
          } else if (!running && this.animationFrame) {
            cancelAnimationFrame(this.animationFrame);
            this.animationFrame = 0;
            this.lastTime = 0;
          }
        };
        this.pauseButton?.addEventListener('click', () => {
          this.manualPause = !this.manualPause;
          this.pauseButton.setAttribute('aria-pressed',String(this.manualPause));
          this.pauseButton.setAttribute('aria-label',this.manualPause ? this.pauseButton.dataset.resumeLabel : this.pauseButton.dataset.pauseLabel);
          this.sync();
        }, {signal});
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); }
        }, {signal});
        this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, {signal});
        this.addEventListener('focusin', event => { this.focused = this.track.contains(event.target); this.sync(); }, {signal});
        this.addEventListener('focusout', event => { this.focused = this.track.contains(event.relatedTarget); this.sync(); }, {signal});
        this.track.addEventListener('pointerdown', () => { this.interacting = true; this.sync(); }, {signal});
        const release = () => { this.interacting = false; this.sync(); };
        window.addEventListener('pointerup',release,{signal});
        window.addEventListener('pointercancel',release,{signal});
        document.addEventListener('visibilitychange',this.sync,{signal});
        this.motion.addEventListener('change',this.sync,{signal});
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.onScreen = entries[0].isIntersecting;
          this.sync();
        }, {rootMargin:'100px'});
        this.visibilityObserver.observe(this);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = 0;
        this.visibilityObserver?.disconnect();
        this.autoController?.abort();
        this.autoController = null;
        super.disconnectedCallback();
      }
    });
})();
